module.exports = __webpack_public_path__ + "img/Logo_MonicaGroups_Couleurs_RVB.5ac95e30.svg";